var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 140.05,
    y1: -151.58,
    x2: 140.05,
    y2: -281.67,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ecf0f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 106.63,
    y1: -205.23,
    x2: 113.15,
    y2: -239.32,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0bacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969eae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 137.18,
    y1: -199.39,
    x2: 143.7,
    y2: -233.48,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 165.78,
    y1: -193.92,
    x2: 172.3,
    y2: -228.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 194.64,
    y1: -294.22,
    x2: 248.13,
    y2: -294.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 63.91,
    y1: -212.88,
    x2: 213.28,
    y2: -212.88,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#eaeef9}.cls-3{fill:#989fb0}.cls-4{fill:#858b9b}.cls-6{fill:none;stroke:#d5ddea;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.3 128.87c0 28.06-11.46 53.36-29.84 71.54-17.98 17.99-42.88 28.85-70.36 28.85s-52.17-11.07-70.36-28.85c-18.38-18.18-29.84-43.48-29.84-71.54 0-55.53 44.86-100.4 100.2-100.4s100.2 45.06 100.2 100.4ZM232.61 63.05c4.48 0 8.1-3.63 8.1-8.1s-3.63-8.1-8.1-8.1-8.1 3.63-8.1 8.1 3.63 8.1 8.1 8.1ZM244.47 31.43a5.529 5.529 0 1 0 0-11.06c-3.05 0-5.53 2.48-5.53 5.53s2.48 5.53 5.53 5.53ZM44.07 62.86a5.529 5.529 0 1 0 0-11.06c-3.05 0-5.53 2.48-5.53 5.53s2.48 5.53 5.53 5.53ZM10.28 169.58c5.68 0 10.28-4.6 10.28-10.28s-4.6-10.28-10.28-10.28S0 153.62 0 159.3s4.6 10.28 10.28 10.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.67 71.32v109.5c0 4.56-3.65 8.17-8.12 8.17H57.62c-4.47 0-8.18-3.67-8.18-8.17V71.32c0-4.5 3.65-8.17 8.18-8.17h164.93c4.47 0 8.12 3.67 8.12 8.17Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.67 71.32v12.25H49.44V71.32c0-4.5 3.65-8.17 8.18-8.17h164.93c4.47 0 8.12 3.67 8.12 8.17Z",
    style: {
      fill: "#d5ddea"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.85 76.41c1.69 0 3.06-1.38 3.06-3.08s-1.37-3.08-3.06-3.08-3.06 1.38-3.06 3.08 1.37 3.08 3.06 3.08ZM70.86 76.41c1.69 0 3.06-1.38 3.06-3.08s-1.37-3.08-3.06-3.08-3.06 1.38-3.06 3.08 1.37 3.08 3.06 3.08ZM80.8 76.41c1.69 0 3.06-1.38 3.06-3.08s-1.37-3.08-3.06-3.08-3.06 1.38-3.06 3.08 1.37 3.08 3.06 3.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.27 158.15h105.56M103.93 169.45h72.26"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.4 126.31v6.1h-3.71v5.86h-6.94v-5.86h-15.3v-6.98l14.18-19.83h8.12v20.77h3.65v-.06Zm-10.65-12.61-8.83 12.61h8.83V113.7Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.82 138.91c-7.41 0-13.95-6.51-13.95-17.05s6.47-17.05 13.95-17.05 13.95 6.51 13.95 17.05-6.47 17.05-13.95 17.05Zm0-6.27c3.47 0 6.94-3.49 6.94-10.71s-3.47-10.71-6.94-10.71-6.94 3.49-6.94 10.71 3.47 10.71 6.94 10.71Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71 126.31v6.1H180v5.86h-6.94v-5.86h-15.3v-6.98l14.18-19.83h8.12v20.77h3.65v-.06ZM173 113.7l-8.83 12.61H173V113.7Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m222.66 213.16-39.42-39.39 9.04-9.04 39.39 39.42-9.01 9.01Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m236.36 227.02-30.23-30.23c-2.52-2.52-2.52-6.64 0-9.16 2.52-2.52 6.64-2.52 9.16 0l30.23 30.23c2.52 2.52 2.52 6.64 0 9.16s-6.64 2.52-9.16 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m234.21 228.96-38.89-38.89c-.9-.9-.9-2.37 0-3.3l9.94-9.94c.91-.9 2.37-.9 3.3 0l38.89 38.89c.9.9.9 2.37 0 3.3l-9.94 9.94c-.94.9-2.4.9-3.3 0Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.61 46.85c-41.26 0-74.7 33.44-74.7 74.7s33.44 74.7 74.67 74.7 74.7-33.44 74.7-74.7-33.44-74.7-74.67-74.7Zm0 135.56c-33.13 0-59.96-27.27-59.96-60.89s26.83-60.86 59.96-60.86 59.96 27.27 59.96 60.89-26.86 60.86-59.96 60.86Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsg404);
export default __webpack_public_path__ + "static/media/esg_404.a269666aeb0325f4ab9f88a82d9a8758.svg";
export { ForwardRef as ReactComponent };